import * as React from 'react';
import { Box, Card, CardActions, Button, Typography } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import CodeIcon from '@mui/icons-material/Code';
import { useTranslate } from 'react-admin';

import publishArticleImage from './welcome_illustration.svg';
import { Link } from 'react-router-dom';

const Welcome = () => {
    const translate = useTranslate();
    const msIntellicheckApiKey = process.env.REACT_APP_VERIFICATIONS_API_KEY || 'api key not setup';
    const verificationsUrl = process.env.REACT_APP_VERIFICATIONS_API_URL || 'not setup url';
    const logsUrl =  process.env.REACT_APP_API_URL||'not setup';
    const automationsUrl = process.env.REACT_APP_AUTOMATIONS_API_URL || 'not setup';

    return (
        <Card
            sx={{
                background: theme =>
                    theme.palette.mode === 'dark'
                        ? '#535353'
                        : `linear-gradient(to right, #8975fb 0%, #746be7 35%), linear-gradient(to bottom, #8975fb 0%, #6f4ceb 50%), #6f4ceb`,

                color: '#fff',
                padding: '20px',
                marginTop: 2,
                marginBottom: '1em',
            }}
        >
            <Box display="flex">
                <Box flex="1">
                    <Typography variant="h5" component="h2" gutterBottom>
                        {translate('pos.dashboard.welcome.title')}
                    </Typography>
                    <Box maxWidth="40em">
                        <Typography variant="body1" component="p" gutterBottom>
                            {translate('pos.dashboard.welcome.subtitle')}
                        </Typography>
                    </Box>

                    <Typography variant="body1" component="p" gutterBottom>
                        Logs url: {logsUrl}
                    </Typography>
                    <Typography variant="body1" component="p" gutterBottom>
                        Automations url: {automationsUrl}
                    </Typography>
                    <Typography variant="body1" component="p" gutterBottom>
                        Intellicheck url: {verificationsUrl}
                    </Typography>
                    <Typography variant="body1" component="p" gutterBottom>
                        Intellicheck ApiKey: {msIntellicheckApiKey}
                    </Typography>
                    
                    


                    <CardActions
                        sx={{
                            padding: { xs: 0, xl: null },
                            flexWrap: { xs: 'wrap', xl: null },
                            '& a': {
                                marginTop: { xs: '1em', xl: null },
                                marginLeft: { xs: '0!important', xl: null },
                                marginRight: { xs: '1em', xl: null },
                            },
                        }}
                    >
                        
                    </CardActions>
                </Box>
                <Box
                    display={{ xs: 'none', sm: 'none', md: 'block' }}
                    sx={{
                        background: `url(${publishArticleImage}) top right / cover`,
                        marginLeft: 'auto',
                    }}
                    width="16em"
                    height="9em"
                    overflow="hidden"
                />
            </Box>
        </Card>
    );
};

export default Welcome;
